import api from "@/config/apiConfig"

class QueuesOptionsController {

  async index ( req ) {
    try {
      const response = await api.get("/queue-option", { params: { ...req }});
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesOptionsController.index: ", error );
      throw error;
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( `/queue-option`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesOptionsController.create: ", error );
      throw error;
    }
  }
  async update ( req ) {
    try {
      const response = await api.patch( `/queue-option/${ req.id }`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesOptionsController.update: ", error );
      throw error;
    }
  }
  async delete ( req ) {
    try {
      const response = await api.delete( `/queue-option/${ req }` )
      return response.data
    } catch ( error ) {
      console.error( "Erro no QueuesOptionsController.delete: ", error )
      throw error
    }
  }
}

export default new QueuesOptionsController()
